import { ReactNode } from 'react'
import Tooltip from '../Tooltip'
import { DataType } from '../../utils'

interface CustomActionItemProps {
  row: DataType | null
  tooltip: string
  dataQaId: string
  onClick: () => void
  icon: ReactNode
  className?: string
}

const CustomActionItem = ({
  row,
  tooltip,
  dataQaId,
  onClick,
  icon,
  className,
}: CustomActionItemProps) => {
  return (
    <Tooltip content={tooltip} position="top" cssClassName="flex">
      <button
        type="button"
        onClick={onClick}
        className={`${row?.disabled ? 'pointer-events-none' : ''} ${className}`}
        data-qa-id={dataQaId}
      >
        {icon}
      </button>
    </Tooltip>
  )
}

export default CustomActionItem
